
export const sFechaPublicacion = '2026-10-10T22:19:58.1487818-06:00';
export const sVersion = 'vf1.1.610102219';
            